/**
 * CHECKS
 */

/**
 * Determina si el objeto recibido está vacío
 *
 * @param      {Object}   obj     The object
 * @return     {boolean}  True if empty, False otherwise.
 */
window.isEmpty = function (obj) {
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }
    return true;
};

/**
 * OVERWRITE
 */

/**
 * Overwrites old selector Contains case Insensitive & Accents
 */
$.expr[":"].contains = $.expr.createPseudo(function (arg) {
    return function (elem) {
        var rExps   = [
            {
                re: /[\xC0-\xC6]/g,
                ch: "A"
            },
            {
                re: /[\xE0-\xE6]/g,
                ch: "a"
            },
            {
                re: /[\xC8-\xCB]/g,
                ch: "E"
            },
            {
                re: /[\xE8-\xEB]/g,
                ch: "e"
            },
            {
                re: /[\xCC-\xCF]/g,
                ch: "I"
            },
            {
                re: /[\xEC-\xEF]/g,
                ch: "i"
            },
            {
                re: /[\xD2-\xD6]/g,
                ch: "O"
            },
            {
                re: /[\xF2-\xF6]/g,
                ch: "o"
            },
            {
                re: /[\xD9-\xDC]/g,
                ch: "U"
            },
            {
                re: /[\xF9-\xFC]/g,
                ch: "u"
            },
            {
                re: /[\xC7-\xE7]/g,
                ch: "c"
            },
            {
                re: /[\xD1]/g,
                ch: "N"
            },
            {
                re: /[\xF1]/g,
                ch: "n"
            },
        ];
        var element = $(elem).text();
        $.each(rExps, function () {
            element = element.replace(this.re, this.ch);
            arg     = arg.replace(this.re, this.ch);
        });
        return element.toUpperCase().indexOf(arg.toUpperCase()) >= 0;
    };
});


/**
 * COOKIES
 *
 * @deprecated: Sustituida por la libreria js-cookie
 */

/**
 * Store a new cookie in the browser
 *
 * @param   {string}  cname     Name of the cookie
 * @param   {string}  cvalue    Value of the cookie
 * @param   {integer} exdays    Expires Days of the cookie
 *
 * @returns void
 */
/* window.setCookie = function (cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    document.cookie = btoa(cname) + "=" + btoa(cvalue) + ";" + expires + ";path=/";
} */

/**
 * Get a prestored cookie
 *
 * @param   {string}    cname   Name of of the cookie
 *
 * @returns {string}    The value of the cookie | ""
 */
/* window.getCookie = function (cname) {
    var name = btoa(cname) + "=";
    var ca = document.cookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return atob(c.substring(name.length, c.length));
        }
    }
    return "";
} */

/**
 * Delete a prestored cookie
 *
 * @param   {string}    cname   Name of the cookie
 */
/* window.deleteCookie = function (cname) {
    document.cookie = btoa(cname) + "=;" + "expires=Thu, 01 Jan 1970 00:00:00 GMT";
} */

/**
 * LOCAL STORAGE
 */

/**
 * Store a new settings in the browser
 *
 * @param   {string}    name Name of the setting
 * @param   {string}    val Value of the setting
 *
 * @returns void
 */
window.setStorage = function (name, val) {
    if (typeof Storage !== "undefined") {
        localStorage.setItem(name, val);
    } else {
        window.alert(
            "Please use a modern browser to properly view this template!"
        );
    }
};

/**
 * Get a prestored setting
 *
 * @param   {string}    name Name of the setting
 *
 * @returns {string}    The value of the setting | null
 */
window.getStorage = function (name) {
    if (typeof Storage !== "undefined") {
        return localStorage.getItem(name);
    } else {
        window.alert(
            "Please use a modern browser to properly view this template!"
        );
    }
};

/**
 * INPUTS EVENTS
 */

/**
 * Permitir valores de cantidad y backspace, delete, tab, escape, enter y .
 */
window.allowQuantityValues = function (e) {
    if (
        $.inArray(e.keyCode, [
            46,
            8,
            9,
            27,
            13,
            110,
            190
        ]) !== -1 ||
        (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
        (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
        (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
        (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
        return;
    }
    if (
        (e.shiftKey || e.keyCode < 48 || e.keyCode > 57) &&
        (e.keyCode < 96 || e.keyCode > 105)
    ) {
        e.preventDefault();
    }
};

/**
 * PARSINGS AND CONVERSIONS
 */

/**
 * Format a number and return a string based on input settings
 *
 * @param {Number} number The input number to format
 * @param {Number} decimals The amount of decimals
 * @param {String} decimalPoint The decimal point
 * @param {String} thousandsSep The thousands separator
 */
window.number_format = function (number, decimals = 2, decimalPoint = ',', thousandsSep = '.') {
    // Strip all characters but numerical ones.
    number         = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n          = !isFinite(+number) ? 0 : +number,
        prec       = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep        = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep,
        dec        = (typeof decimalPoint === 'undefined') ? '.' : decimalPoint,
        s          = '',
        toFixedFix = function (n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    // Fix for IE parseFloat(0.55).toFixed(0) = 0;
    s              = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

/**
 * Format a date
 *
 * @param {String} date   The date to format
 * @param {String} originalFormat The original format of date
 * @param {String} format The format to set
 *
 * @returns {String} Based on input settings
 */
window.date_format = function (date, originalFormat = "DD-MM-YYYY h:mm:ss.a", format = "DD/MM/YYYY") {
    return moment(date, originalFormat).format(format);
}

/**
 * Parses qoutes of a string
 *
 * @param {String} str The string to parse
 *
 * @returns {String} The parsed string
 */
window.parseQuotes = function (str) {
    return str.replace(/[\u2018\u2019]/g, '\'').replace(/[\u201C\u201D]/g, '\"');
}

/**
 * Convert all applicable characters to HTML entities
 *
 * @param {String} str The string to convert
 *
 * @returns {String} The converted string
 */
window.htmlEntities = function (str) {
    return str.replace(/[\u00A0-\u9999<>\&]/g, function (i) {
        return '&#' + i.charCodeAt(0) + ';';
    });
}

/**
 * Pascal Case
 *
 * Convierte un string en Pascal Case
 *
 * @param      {string}  string   The string to convert
 */
window.pascalCase = function (string) {
    let camelString = camelCase(string);
    return camelString.charAt(0).toUpperCase() + camelString.slice(1);
};

/**
 * Camel Case
 *
 * Convierte un string en Camel Case
 *
 * @param      {string}  string   The string to convert
 */
window.camelCase = function (string) {
    return string.replace(/[\s_\-](\w)/g, function (_, firstChar) {
        return firstChar.toUpperCase();
    });
};

/**
 * ucwords php
 *
 * Idem Camel Case
 *
 * Converts the first character of each word in a string to uppercase
 *
 * @param      {string}  strin   The string to convert
 */
window.ucwords = function (strin) {
    strin.toLowerCase().replace(/\b[a-z]/g, function (letter) {
        return letter.toUpperCase();
    });
};

/**
 * ucfirst php
 *
 * Convert the first character of a string to uppercase
 *
 * @param      {string}  strin   The string to convert
 */
window.ucfirst = function (strin) {
    return strin.charAt(0).toUpperCase() + strin.slice(1).toLowerCase();
};

/**
 * ERRORS HANDLING & VALIDATIONS
 */

/**
 * Compose the validation error message
 *
 * @param errors {array} The validation errors
 *
 * @returns {string} The validation error message formatted in html format
 */
window.composeValidationError = function (errors) {
    let errorMessage = '';
    $.each(errors, function (i, fieldErrors) {
        $.each(fieldErrors, function (j, fieldError) {
            errorMessage = fieldError;
            if (fieldErrors.length > 1 && j > 0) {
                errorMessage = errorMessage + '</br>';
            }
        });
    });
    return errorMessage;
}

/**
 * Validate File
 *
 * @param {file}  file
 * @param {array} allowedExtensions
 * @param {int}   maxSize
 * @returns {{result: boolean, message: string}}
 */
window.validateFile = function (file, allowedExtensions = [], maxSize = 10) {
    // Evitamos que salte la validación si el file no se envía o está vacío
    if ('undefined' !== typeof file) {
        // Gets file size in MB
        let fileSize = file.size / 1024 / 1024;

        if (fileSize > maxSize) {
            return {
                result:  false,
                message: transFileMaxSize,
            };
        }

        if (-1 === $.inArray(file.name.split('.').pop().toLowerCase(), allowedExtensions)) {
            return {
                result:  false,
                message: transFileInvalidFormat + allowedExtensions.join(', '),
            };
        }
    }

    return {
        result: true,
    };
}

/**
 * MISCELLANY / OTHERS
 */

/**
 * Delay
 */
window.throttle = function (f, delay) {
    let timer = null;
    return function () {
        let context = this,
            args    = arguments;
        clearTimeout(timer);
        timer = window.setTimeout(function () {
            f.apply(context, args);
        }, delay || 750);
    };
};

/**
 * Convert string to color.
 *
 * @param    string    $str    The string to convert
 *
 * @return   string    The color on hexadecimal format
 *
 * @author   Raúl García Titos <rgarcia@trevenque.es>
 * @version  0.0.2
 * @date     18/10/2021 10:29:29
 */
window.strToColor = function (str) {
    let charCode = str.charCodeAt(0);
    let red      = (charCode % 16).toString(16);
    let green    = ((charCode + 4) % 16).toString(16);
    let blue     = ((charCode + 8) % 16).toString(16);
    let hexColor = "#" + red + green + blue;
    return hexColor;
}
